import React, { useState } from 'react';
import { View, Radio, Text, Divider } from '@upstox/upstox-ui';
import LocaleService from 'modules/Localization';
import Modal from 'app/components/MainLayout/components/Modal';
import { ModalFooter } from 'app/components/MainLayout/components/Modal/ModalFooter';

interface OrderReviewModalProps {
  onClose: () => void;
  handleSave: (isOrderReviewEnabled: OrderReviewState) => void;
  OrderReviewOptions: OrderReviewState[];
  defaultValue?: OrderReviewState;
}

const OrderReviewOptionsList: Record<string, string> = {
  true: LocaleService.translate('WANT_TO_REVIEW'),
  false: LocaleService.translate('DONT_WANT_TO_REVIEW'),
};

export const OrderReviewModal = ({
  onClose,
  OrderReviewOptions,
  handleSave,
  defaultValue = 'true',
}: OrderReviewModalProps) => {
  const [isOrderReviewEnabled, setIsOrderReviewEnabled] = useState<
    OrderReviewState
  >(defaultValue);

  return (
    <Modal onClose={onClose} title="Review order every time?">
      <View margin={['small', 'xlarge']}>
        <Text>
          {LocaleService.translate('ORDER_REVIEW_INSTRUCTION_TEXT')}
        </Text>
      </View>
      {OrderReviewOptions.map(option => (
        <View key={option} as="div" gap="medium" margin={['small', 'xlarge']}>
          <Radio
            style={{ outline: 'none' }}
            name="notification-types"
            value={option}
            id={option}
            checked={option === isOrderReviewEnabled}
            onChange={e =>
              setIsOrderReviewEnabled(
                e.currentTarget.value as OrderReviewState,
              )}
          />
          <Text htmlFor={option} as="label" family="tvFont">
            {OrderReviewOptionsList[option]}
          </Text>
        </View>
      ))}
      <Divider />
      <ModalFooter
        onClose={onClose}
        confirmActionTitle="Save"
        onConfirm={() => {
          handleSave(isOrderReviewEnabled);
          onClose();
        }}
      />
    </Modal>
  );
};
